import classNames from 'clsx'
import { number, oneOf, string } from 'prop-types'

import {
  AVAILABLE_PRESCRIPTION_TYPES,
  PRESCRIPTION_TYPE_FREE,
  PRESCRIPTION_TYPE_INSURANCE,
  PRESCRIPTION_TYPE_PRIVAT,
} from 'shared/consts/productTemplates'
import BonusBadge from 'views/components/atoms/BonusBadge'
import Price from 'views/components/atoms/Price'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import { PRESCRIPTION_BONUS_MODAL_ID } from 'views/consts'

import './ProductBonusBadge.scss'

const ProductBonusBadge = ({ prescriptionType, bonus, className }) => {
  const buttonClassName = classNames(className, 'o-ProductBonusBadge')

  return (
    <div className="o-ProductTemplate__gallery--badge">
      <ModalShowButton
        component={ButtonAsLink}
        name="Bonus-modal"
        className={buttonClassName}
        aria-hidden={
          ![
            PRESCRIPTION_TYPE_INSURANCE,
            PRESCRIPTION_TYPE_FREE,
            PRESCRIPTION_TYPE_PRIVAT,
          ].includes(prescriptionType)
            ? true
            : null
        }
        modalId={PRESCRIPTION_BONUS_MODAL_ID}
      >
        <BonusBadge>
          <Price amount={bonus} />
        </BonusBadge>
      </ModalShowButton>
    </div>
  )
}

ProductBonusBadge.propTypes = {
  prescriptionType: oneOf(AVAILABLE_PRESCRIPTION_TYPES.ALL),
  bonus: number.isRequired,
  className: string,
}
ProductBonusBadge.defaultProps = {
  prescriptionType: null,
  className: null,
}

export default ProductBonusBadge
